export default __webpack_public_path__ + "static/bagic_english-b112b505e20affdbf2dbe93d9242c99b.jpg";